const BxfCardGroupConstants = {
    CARD: 'bxf-card',
    CARD_GROUP: 'bxf-card-group',
    CARD_GROUP_CONTAINER: 'bxf-card-group__container',
};

export { BxfCardGroupConstants as B };
